import decode from 'jwt-decode'

import Storage from '@st-operations/uikit/Storage.js'
import pretty from '@st-operations/uikit/lib/pretty.js'

import TEAM_ID from '_constants/sharethis_team_id.js'
import User from '_lib/User.js'

import { changeUserOrg, deleteUser } from '_services/permissions'
import { OPTION_NAMES } from './constants'
import Cookies from '_lib/cookies'

export const filterQuery = (query, list) => {
  const lowCaseQuery = query.toLowerCase()
  return list.filter(
    ({ email, name }) =>
      (email || '').toLowerCase().includes(lowCaseQuery) ||
      (name || '').toLowerCase().includes(lowCaseQuery)
  )
}

export const filterOrg = (org, list) => (org ? list.filter((user) => user.org === org.value) : list)

export const sortUsers = ({ type, direction }, list) => {
  if (type === null) return list
  const newList = list.toSorted((a, b) => (a[type] ?? '').localeCompare(b[type] ?? ''))
  if (direction === 'desc') newList.reverse()
  return newList
}

export const getTeamInfo = ({ setPermissions, setInvitations }) => {
  User.getTeamInfo(TEAM_ID, (err, team) => {
    if (err) {
      this.setState({ has_team: false })
      toast('Error getting your team information')
    } else {
      setPermissions(team.acl)
      setInvitations(team.invitations)
    }
  })
}

export const formatOrg = (orgs) =>
  orgs.map((org) => ({
    value: org,
    label: pretty(org),
    isDisabled: false,
  }))

export const sendInvite = ({ email, roles, org }) => {
  User.sendInvite({ email, roles, org, team_id: TEAM_ID }, (error) => {
    if (error) {
      toast.error(`Error inviting ${email}`)
    } else {
      toast(`${email} should receive an invitation shortly!`)
    }
  })
}

export const updatePermissions = ({ roles, id }) => {
  User.updateUserPermission(roles, TEAM_ID, id, (error) => {
    if (error) {
      toast.error(`Error updating permissions: ${error.message}`)
    } else {
      toast('User permissions updated!')
    }
  })
}

export const updateOrg = ({ id, org }) => {
  changeUserOrg({ id, org })
    .then(({ notification }) => toast(notification))
    .catch((error) => toast.error(`Error updating org: ${error.message}`))
}

export const delUser = ({ id, email }) =>
  deleteUser(id)
    .then((data) => toast(`${email} removed with success`))
    .catch((error) => toast.error(`Error deleting: ${error.message}`))

export const checkAdmin = () => {
  const token = Cookies.getCookie('token')
  const data = decode(token)
  return data?.datasphere_admin
}

export const getOptions = ({ isShareThis, isAdmin, isEditing }) => {
  return [
    OPTION_NAMES.ACCOUNT_SETTINGS,
    isShareThis && OPTION_NAMES.INVITE_NEW_MEMBER,
    isShareThis && OPTION_NAMES.INVITATIONS,
    isShareThis && OPTION_NAMES.MANAGE_COLLABORATORS,
    isShareThis && isEditing && OPTION_NAMES.EDIT_COLLABORATOR,
    isShareThis && isAdmin && OPTION_NAMES.MANAGE_PERMISSION_SETS,
  ].filter(Boolean)
}
